module.exports = __webpack_public_path__ + "img/about_8.32232f47.jpg";